// extracted by mini-css-extract-plugin
export default {"stopwordList":"StopwordsList_stopwordList__Q31PA","stopwordItem":"StopwordsList_stopwordItem__7k3KU","stopwordsHeader":"StopwordsList_stopwordsHeader__2jFAG"};